import { render, staticRenderFns } from "./EventoCard.vue?vue&type=template&id=40bc7e6d"
import script from "./EventoCard.vue?vue&type=script&lang=js"
export * from "./EventoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports